import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { OrderHistoryPageInitialData } from "./orderHistoryPageInitialData";

export const orderHistoryPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("orders"),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<OrderHistoryPageInitialData>>("/page-data/my-account/orderHistory"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
